export default {
  roles: "Rôles",
};
